import { CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot, 
    Router} from "@angular/router";
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { Stitch, StitchAppClient } from 'mongodb-stitch-browser-sdk';
import {
  HttpServiceClient,
  HttpRequest,
  HttpMethod
} from 'mongodb-stitch-browser-services-http';
import { HttpClient } from '@angular/common/http';
import { Api } from 'src/app/provider/api';



 @Injectable()
export class VideoService{
    
    //THis is used to call video related quired from stitch
    //serviceName : 'videoLibrary/incoming_webhook/';

    
    constructor(private api:Api){
   
    }

    getVideoCategory(category : string){
       let videoSubjects = this.api.get("videoLibrary/incoming_webhook/videoCategory");
       videoSubjects.subscribe((res: any)=>{
       
         //  console.log(res);
          }, err => {
            console.error('ERROR', err)
          });
        return videoSubjects;
    }

    getAllVideosListInCategory(category : any){
        let videoSubjects = this.api.post("videoLibrary/incoming_webhook/getAllVideoList",category);
        videoSubjects.subscribe((res: any)=>{
        
          //  console.log(res);
           }, err => {
             console.error('ERROR', err)
           });
         return videoSubjects;
    }


    getVideoDetails(category : any){
      let videoSubjects = this.api.post("videoLibrary/incoming_webhook/watchVideo",category);
      videoSubjects.subscribe((res: any)=>{
      
         // console.log(res);
         }, err => {
           console.error('ERROR', err)
         });
       return videoSubjects;
  }


  getVideoInstructor(instructor_id : any){
    let videoInstructor = this.api.post("videoLibrary/incoming_webhook/getInstructorDetails",instructor_id);
    videoInstructor.subscribe((res: any)=>{
    
       // console.log(res);
       }, err => {
         console.error('ERROR', err)
       });
     return videoInstructor;
  }


  getVideoCME(instructor_id : any){
    let videoInstructor = this.api.post("videoLibrary/incoming_webhook/isCmeAvailable",instructor_id);
    videoInstructor.subscribe((res: any)=>{
    
       // console.log(res);
       }, err => {
         console.error('ERROR', err)
       });
     return videoInstructor;
  }



  getCMEQuestions(instructor_id : any){
    let videoInstructor = this.api.post("videoLibrary/incoming_webhook/getCMEQuestions",instructor_id);
    videoInstructor.subscribe((res: any)=>{
    
       // console.log(res);
       }, err => {
         console.error('ERROR', err)
       });
     return videoInstructor;
  }



  

  

/*
    getVideoCategory(category : string){
        const app : any = Stitch.defaultAppClient;
        const http  = app.getServiceClient(HttpServiceClient.factory, "videoLibrary");
    const request = new HttpRequest.Builder()
    .withMethod(HttpMethod.POST)
    .withUrl("https://us-east-1.aws.webhooks.mongodb-stitch.com/api/client/v2.0/app/drbeen-stage-zujks/service/videoLibrary/incoming_webhook/videoCategory")
    .build();
    http.execute(request)
    .then( resp =>{
        console.log(resp);
    })
    .catch(console.error);

}*/
    
       
    
    }